import { types } from "../types/types";

const initialState= {
    modalOpen: false,
    item:""

}




export const uiReducer = ( state = initialState, action ) => {
// console.log(action.payload)

    switch ( action.type ) {
        case types.uiOpenModal:
            
           return {
               ...state,
               modalOpen: true,
               item: {...action.payload}
           }
        case types.uiCloseModal:
            
           return {
               ...state,
               modalOpen: false,
               item: ""
           }
    
        default:
            return state;
    }


}